// Where the site's data comes from. Production values are in .env.production; the defaults here
// are for local development, where vite.config.ts serves the pipelines' output (var/public) at
// /dev-data/.

import { OVERVIEW_TILES_NAME } from "@transitopia/shared/transit-overview.ts";

const env = import.meta.env;

/** Absolute URL for a site-relative path (pmtiles:// and MapLibre glyph URLs must be absolute). */
function absolute(path: string): string {
  return path.startsWith("/") ? `${location.origin}${path}` : path;
}

/** The basemap source: a TileJSON URL, or pmtiles:// for a local extract (npm run tiles -- --region bc). */
export const basemapTiles: string =
  env.VITE_BASEMAP_TILES
  ?? `pmtiles://${absolute("/dev-data/tiles/protomaps-bc.pmtiles")}`;

/** Basemap fonts and sprites (pipelines/tiles.ts), ending in "/". */
export const basemapAssets: string = absolute(
  env.VITE_BASEMAP_ASSETS ?? "/dev-data/basemap-assets/",
);

/**
 * Published data, ending in "/": transit (…/data/feeds/<feed>/manifest.json) and cycling
 * (…/data/cycling/<area>/index.json, CyclingMap/cycling-data.ts).
 */
export const transitData: string = env.VITE_TRANSIT_DATA ?? "/dev-data/";

/**
 * The API server (…/feeds/<id>/live), ending in "/"; undefined for schedules only. In
 * development, the local one (npm run server) unless VITE_TRANSIT_API says otherwise
 * (vite.config.ts): set it empty for schedules only.
 */
export const transitApi: string | undefined = env.VITE_TRANSIT_API || undefined;

/**
 * Every feed's routes zoomed out (packages/transit-core/DESIGN.md#overview-tiles): from the tile
 * worker (a URL ending in "/"), else the local build (npm run build:overview-tiles).
 */
export const transitOverviewTiles: string =
  env.VITE_TRANSIT_OVERVIEW_TILES_CDN ?
    `${env.VITE_TRANSIT_OVERVIEW_TILES_CDN}${OVERVIEW_TILES_NAME}.json`
  : `pmtiles://${absolute(`/dev-data/tiles/${OVERVIEW_TILES_NAME}.pmtiles`)}`;

/**
 * The production site, for canonical URLs: preview builds and local runs point search engines there
 * too. VITE_SITE_URL for another deployment (vite.config.ts sets the default).
 */
export const siteUrl = (
  env.VITE_SITE_URL ?? "https://www.transitopia.org"
).replace(/\/$/, "");
